import { render, staticRenderFns } from "./WsInfiniteLayers2.vue?vue&type=template&id=dd6d64a0&"
import script from "./WsInfiniteLayers2.vue?vue&type=script&lang=js&"
export * from "./WsInfiniteLayers2.vue?vue&type=script&lang=js&"
import style0 from "./WsInfiniteLayers2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
